import { render, staticRenderFns } from "./agunandetail.vue?vue&type=template&id=f0e27524&scoped=true&"
import script from "./agunandetail.vue?vue&type=script&lang=js&"
export * from "./agunandetail.vue?vue&type=script&lang=js&"
import style0 from "./agunandetail.vue?vue&type=style&index=0&id=f0e27524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e27524",
  null
  
)

export default component.exports